import React, { useEffect, useState, useRef } from "react";
import { Col, Row, Card, Result, Spin } from "antd";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { LoadingOutlined } from '@ant-design/icons';


export default function PostPurchase() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const paymentLinkId = searchParams.get("paymentLinkId");

    const [validating, setValidating] = useState(true);
    const [error, setError] = useState(null);
    const hasValidated = useRef(false); // Ref to track if validation has occurred

    useEffect(() => {
        const validate = async () => {
            if (hasValidated.current) return; // Prevent further validation calls
            hasValidated.current = true; // Mark as validated

            try {
                const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/busable-inject-functions/busable/stripe/validate`, {
                    token,
                    courseId: id,
                    paymentLinkId
                });

                if (res.data.success) {
                    navigate(`/courses/${res.data.id}`);
                } else {
                    toast.error("Something went wrong, please contact an administration");
                    setError("Course purchase validation failed");
                }
            } catch (error) {
                console.error("Validation failed:", error);
                setError("Validation request failed");
            } finally {
                setValidating(false);
            }
        };

        // Ensure both token and id are available before calling
        if (token && id) {
            validate();
        }
    }, [id, token, navigate, paymentLinkId]);

    if (error) {
        return (
            <div className="CourseSingle PageSingle">
                
                <div className="AppContainer">
                    <Row gutter={[20, 20]}>
                        <Col lg={24} xs={24}>
                            <Card bordered={false} className="CardItem">
                                <Result status="warning" title="Something went wrong" subTitle="Please contact an administrator"/>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }

    return (
        <div className="CourseSingle PageSingle">
            <div className="AppContainer">
                <Row gutter={[20, 20]}>
                    <Col lg={24} xs={24}>
                        {validating ? (
                            <Card bordered={false} className="CardItem">
                                <Result icon={<Spin indicator={<LoadingOutlined style={{fontSize: 60}} spin />}/>} title="Validating course purchase" subTitle="Please do not close or refresh the page. You will automatically be redirected once verified"/>
                            </Card>
                        ) : (
                            <Card bordered={false} className="CardItem">
                                <Result status="success" title="Successfully purchased course" subTitle="Redirecting now"/>
                            </Card>
                        )}
                    </Col>
                </Row>
            </div>
        </div>
    );
}
